var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSierraLeone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 21.5749C31.648 19.8416 32 17.9668 32 16.0097C32 14.0526 31.648 12.1778 31.0048 10.4445L16 9.05322L0.995188 10.4445C0.352 12.1778 0 14.0526 0 16.0097C0 17.9668 0.352 19.8416 0.995188 21.5749L16 22.9662L31.0048 21.5749Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0098C22.8794 32.0098 28.7441 27.6678 31.0047 21.575H0.995117C3.25587 27.6678 9.12049 32.0098 16 32.0098Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.00976562C9.12049 0.00976562 3.25587 4.35177 0.995117 10.4446H31.0048C28.7441 4.35177 22.8794 0.00976562 16 0.00976562Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.00976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSierraLeone);
export default __webpack_public_path__ + "static/media/flag_sierra_leone.fbb37e66df58ee4ce7fd42a67c4fc9e0.svg";
export { ForwardRef as ReactComponent };